import Vue from 'vue'
import API from '../utils/api'
import env from '../../../config/prod.env.js'

const state = {
  typeimpediments: []
}

const mutations = {  
  SET_TYPEIMPEDIMENTS (state, payload) {
    state.typeimpediments = payload
  },
  API_FAILURE (state, payload) {
    throw {error: true, payload: payload.body}
  } 
}

const actions = {
  typeImpedimentList: (context, id) => {
    return Vue.http.get(`${env.API}/api/type-impediment`)    
      .then((response) => {        
        context.commit('SET_TYPEIMPEDIMENTS', response.body.message)
        return response.body.message
      })
      .catch((error) => {
        return context.commit('API_FAILURE', error)
      })
  },
  gettypeImpedimentById: (context, id) => {
    return Vue.http.get(`${env.API}/api/type-impediment/by-id/${id}`)    
      .then((response) => {                
        return response.body.message
      })
      .catch((error) => {
        return context.commit('API_FAILURE', error)
      })
  }
}

const getters = {
  getTypeImpedimets: (state) => state.typeimpediments
}

export const typeimpediment = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/typeimpediments.js